module.exports = __webpack_public_path__ + "static/media/resolutionHalfVotes.10c602c0.svg";